import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=5e2f7566&scoped=true&"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f7566",
  null
  
)

export default component.exports